
<template>
    <div class="row">
        <div class="form-group col-md-12">
            <label >SIC Industries</label>
            <select class="form-control" v-model="selectedIndustry">
                <option value="">Please select a SIC industry</option>
                <option v-for="ind in sic_industries" :value="ind.section_name" :selected="(ind.section_name == selectedIndustry.section_name) ? selected : '' ">{{ind.section_name}}</option>
            </select>
        </div>      
        <div class="form-group col-md-12">
            <label>SIC Codes</label>
            <select class="form-control" v-model="selectedCode" name="sic_codes">
                <!-- <option value="">Please select a SIC code</option> -->
                <option v-for="code in codesList" :key="code.id" :value="code.id"  :selected="(code.id == selectedCode.id) ? selected : '' ">{{code.sic_code}} - {{code.code_name}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: {         
            sections: {},
            siccodes: {},                  
            hassic:[]          
        },

        data() {
            return {
                sic_industries: this.sections,
                selectedIndustry:  this.hassic.section_name!== undefined && this.hassic.section_name!== null ? this.hassic.section_name  : '' ,
                selectedCode: this.hassic.section_name!== undefined && this.hassic.section_name!== null ? this.hassic.id  : '' ,                                 
            }
        },
     mounted() {
     },
        computed: {
            /**
             * returns sic codes by selected industry
             * @return Array the list
             */
            codesList: function () {
                const selected = this.selectedIndustry;                  
                if(selected)   { 
                    return this.siccodes.filter((item) => item.section_name.includes(selected));                                                       
                }
            },      
        },
        methods: {          
           
        }
    }    

</script>
